import React from "react";
import PT from "prop-types";

export function GiftSubscription({ color = "#fff" }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="22px"
      height="22px"
      viewBox="0 0 935.375 935.375"
      xmlSpace="preserve"
      fill={color}
    >
      <g>
        <path
          d="M362.189,34.821C325.89,8.479,287.582-3.011,248.316,0.67c-33.322,3.124-60.324,14.123-80.258,32.69
			c-19.385,18.057-30.58,42.083-32.374,69.48c-2.367,36.164,12.378,75.592,40.456,108.175c0.492,0.571,0.996,1.132,1.496,1.698
			H38.074v265.732h33.219v456.929h792.789V478.447h33.219V212.715H757.736c0.5-0.565,1.004-1.127,1.496-1.698
			c28.078-32.583,42.824-72.012,40.457-108.175c-1.795-27.397-12.988-51.425-32.375-69.48
			c-19.934-18.568-46.936-29.566-80.258-32.69c-39.266-3.68-77.574,7.809-113.873,34.15c-26.717,19.388-52.33,46.951-76.129,81.925
			c-11.295,16.599-21.104,33.273-29.369,48.659c-8.264-15.386-18.072-32.06-29.368-48.659
			C414.52,81.771,388.906,54.208,362.189,34.821z M106.074,300.771v-20.056h723.227v20.057v109.674h-33.219h-213.57h-229.65H139.293
			h-33.219V300.771z M420.862,478.447h93.65v136.35l-46.825-21.688l-46.825,21.688V478.447z M227.654,166.627
			c-16.294-18.909-25.309-41.093-24.114-59.343c0.649-9.924,4.306-18.055,10.867-24.167c8.567-7.98,22.488-13.079,40.257-14.745
			c22.491-2.109,44.457,4.815,67.152,21.167c20.247,14.587,40.299,36.274,59.603,64.458c13.919,20.324,25.4,41.105,34.167,58.717
			h-110.44C274.073,204.938,246.652,188.675,227.654,166.627z M796.08,867.375H139.293V478.447h213.569v242.787l114.825-53.187
			l114.825,53.186V478.447h213.57v388.928H796.08z M553.273,155c19.369-28.464,39.504-50.382,59.85-65.145
			c22.846-16.578,44.951-23.606,67.588-21.483c17.77,1.666,31.689,6.765,40.258,14.745c6.561,6.112,10.217,14.242,10.867,24.167
			c1.193,18.25-7.82,40.435-24.115,59.343c-18.998,22.047-46.42,38.311-77.49,46.087H519.762
			C528.361,195.442,539.605,175.085,553.273,155z"
        />
      </g>
    </svg>
  );
}

GiftSubscription.propTypes = {
  color: PT.string
};
